module.exports = __webpack_public_path__ + "img/myapp-zh.62461e80.png";